import { RECIPE_NODE_TEMPLATE_TYPE } from '../constants/node';

export function isTemplateNodePageType(template) {
  const { type = '' } = template || {};
  return type.toLowerCase() === RECIPE_NODE_TEMPLATE_TYPE.Page.toLowerCase();
}
